<template>
  <el-dialog top="30vh" class="logout-dialog" :visible.sync="isLiveLogout" center :before-close="closeDialog" width="30%">
    <div class="dia-content">
      <span>退出登录会在5分钟后结束直播</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" round @click="toggleLiveLogout(false)">取 消</el-button>
      <el-button class="commit" round type="primary" @click="logout()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../util/http";
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["isLiveLogout"]),
  },

  methods: {
    ...mapMutations(["changeUserInfo", "toggleLiveLogout", "clearChatList"]),
    async logout() {
      const {
        data: { status },
      } = await post({
        url: "/api/user/logout",
      });
      if (status == 0) {
        localStorage.clear();
        this.changeUserInfo({ id: "", diamond: 0, gold: 0 });
        // 退出登录时清空聊天缓存
        this.clearChatList();
        // setTimeout(() => {
        //   this.endLive();
        // }, 5000);
        location.reload();
      }
    },
    closeDialog() {
      this.toggleLiveLogout(false);
    },
    async endLive() {
      try {
        const {
          data: { status },
        } = await post({ url: "/webapi/live/endLive" });
        if (status == 0) {
          this.$router.push("/");
        }
      } catch (e) {
        console.log("退出直播出错", e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logout-dialog {
  ::v-deep .el-dialog__header {
    display: none;
  }
  .dia-content {
    padding: 0.2rem 0.2rem;
    padding-top: 0.3rem;
    color: #333333;
    font-size: 0.18rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cancel,
  .cancel:hover {
    border-color: var(--theme-primary);
    color: var(--theme-primary);
    padding: 0.1rem 0.45rem;
  }
  .commit,
  .commit:hover {
    background-color: var(--theme-primary);
    color: #ffffff;
    border-color: var(--theme-primary);
    padding: 0.1rem 0.45rem;
  }
}
</style>
